import { createAction, props } from '@ngrx/store';

export const NameChange = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Name Changed',
  props<{ name: string }>(),
);

export const NotificationEmailChange = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: NotificationEmail Changed',
  props<{ notificationEmail: string }>(),
);

export const NotificationEmailValidationStatus = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Notification Email Validation Status',
  props<{ isInvalid: boolean }>(),
);

export const StatusChange = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Status Changed',
  props<{ isActive: boolean }>(),
);

export const UsernameChange = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Username Changed',
  props<{ username: string }>(),
);

export const PasswordChange = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Password Changed',
  props<{ password: string }>(),
);

export const LookBackDaysChange = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Look Back Days Changed',
  props<{ lookBackDays: number | null }>(),
);

export const LookBackDaysValidationStatus = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Look Back Days Validation Status',
  props<{ isInvalid: boolean }>(),
);

export const EditQcMessageAppIntegrationSystem = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Edit QcMessageApp Integration System',
  props<{ qcMessageAppData: any }>(),
);

export const CloseQcMessageAppEditIntegration = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Close QcMessageApp Edit Integration',
);

export const ToggleQcEndpointConfHelpTextStatus = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Toggle QcMessageApp Endpoint Configuration Help Text Status',
);

export const ToggleCredentialsConfHelpTextStatus = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Toggle Credentials Configuration Help Text Status',
);

export const ToggleCampaignReportingHelpTextStatus = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Toggle Campaign Reporting Help Text Status',
);

export const SaveQcMessageAppConfiguration = createAction(
  '[QcMessageApp CONFIGURATION]: Save QcMessageApp Configuration',
);

export const SaveQcMessageAppConfigurationSuccess = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Save QcMessageApp Configuration Success',
  props<{ res: any }>(),
);

export const SaveQcMessageAppConfigurationFailed = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Save QcMessageApp Configuration Failed',
  props<{ error: any }>(),
);

export const UpdateQcMessageAppConfiguration = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Update QcMessageApp Configuration',
);

export const UpdateQcMessageAppConfigurationSuccess = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Update QcMessageApp Configuration Success',
  props<{ res: any }>(),
);

export const UpdateQcMessageAppConfigurationFailed = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: Update QcMessageApp Configuration Failed',
  props<{ error: any }>(),
);

export const QcMessageAppSubmitData = createAction(
  '[QC_MESSAGE_APP CONFIGURATION]: QcMessageApp Submit Data',
);
